// extracted by mini-css-extract-plugin
export default {"Screen":"Screen_Screen__0ghyk","Header":"Screen_Header__xSHug","StoryWrapper":"Screen_StoryWrapper__Twmck"};